import styled, { css } from 'styled-components';
import { Col } from 'antd';

export const CustomLabel = styled.label`
	font-size: ${({ theme }) => theme.fonts.label.md.fontSize} !important;
	line-height: ${({ theme }) => theme.fonts.label.md.lineHeight} !important;
	font-weight: ${({ theme }) => theme.fonts.label.md.fontWeight} !important;
	letter-spacing: ${({ theme }) => theme.fonts.label.md.letterSpacing} !important;
	color: ${({ theme }) => theme.colors.text} !important;
	margin-bottom: 16px;
	display: block;
`;

export const CustomBlock = styled.div`
	border-radius: 12px;
	display: flex;
	height: 80px;
	justify-content: space-between;
	align-items: center;
	width: 100%;
	padding: 0 20px;
	background-color: ${({ theme }) => theme.palette.secondary[50]};
`;

export const CustomContainerTooltip = styled.div`
	display: flex;
	align-items: center;
	height: 100%;
`;

export const ContentTool = styled.div<{ isJDS_D86: boolean }>`
	text-align: left;
	margin-left: ${({ isJDS_D86 }) => (isJDS_D86 ? '0px' : '20px')};

	h4 {
		${({ theme }) => css`
			${{ ...theme.fonts.label.md }}
		`}
	}

	p {
		font-size: 14px !important;
		line-height: 16px !important;
		font-weight: 400 !important;
		margin: 0px !important;
	}
`;

export const ColDefaultToolsReview = styled(Col)`
	width: 100%;
	justify-content: flex-start;
	align-items: flex-start;
`;
